import user from "./user";
import card from "./card";

export default {
  user,
  card
}
